export default {
    excess: 'Pašrisks',
    security: 'Drošības depozīts',
    fuel_policy: 'Degvielas politika',
    like_for_like: 'Līdzīgs pret līdzīgu',
    full_to_full: 'Pilna līdz pilnai',
    mileage: 'Nobraukums: {mileage} jūdzes par nomu',
    unlimited_mileage: 'Neierobežots nobraukums',
    non_refundable: 'Nav atmaksājams',
    free_cancellation_until: 'Bezmaksas atcelšana līdz {date}',
    cancellation_with_terms: 'Atcelšana {0} saskaņā ar ',
    t_c_text: 'Noteikumi un nosacījumi',
    two_free_extras: 'Divi bezmaksas papildinājumi saņemot',
    glass_tyres_covered: 'Stikli un riepas ir apdrošinātas',
    spec_fuel_petrol: 'benzīns',
    spec_fuel_petrol_diesel: 'benzīns/dīzelis',
};
